import { useLocation } from 'react-router'

const Register = () => {
    const { state } = useLocation()
    window.location.href = `/register${
        state?.next ? `?next=${state.next}` : ''
    }`
    return null
}

export default Register
